import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import PostPage from "./components/PostPage";
import EPortfolio from "./components/EPortfolio/EPortfolio";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./components/NotFound";
import GradeCalculator from "./components/GradeCalculator/GradeCalculator";
import MythologyHome from "./components/Mythology/MythologyHome";
import MythologyMyths from "./components/Mythology/MythologyMyths";
import MythologyArtifacts from "./components/Mythology/MythologyArtifacts";
import MythologyConclusions from "./components/Mythology/MythologyConclusions";
import MythologyBibliography from "./components/Mythology/MythologyBibliography";

import "./App.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog/:slug" element={<PostPage />} />
            <Route path="/eportfolio" element={<EPortfolio />} />
            <Route path="/grade-calculator" element={<GradeCalculator />} />
            <Route path="/mythology" element={<MythologyHome />} />
            <Route path="/mythology/myths" element={<MythologyMyths />} />
            <Route path="/mythology/artifacts" element={<MythologyArtifacts />} />
            <Route path="/mythology/conclusions" element={<MythologyConclusions />} />
            <Route path="/mythology/bibliography" element={<MythologyBibliography />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
